// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.my-class {\n  /* background-color: #9E9E9E; */\n  border: 2px dashed #FF5722;\n  -webkit-transition: background-color 200ms linear;\n  transition: background-color 200ms linear;\n  position: absolute;\n  text-align: center;\n}\n.my-dragging-class {\n  background-color: rgb(255, 87, 34, 0.7);\n  border: 2px dashed #FF5722;\n}\n.my-active-class{\n  background-color: rgb(255, 87, 34, 0.25);\n  border: 2px dashed #FF5722;\n}\n", ""]);
// Exports
module.exports = exports;
